
import AdminLayout from 'components/layouts/AdminLayout';
import './Home.scss';
import {  Card, Col, Row  } from 'antd';
import UserService from "../../services/UserService";
import { TranslateString } from 'Utils/Common';



const HomeLayout = (props:any) => {
    
 return (
    <>
    <AdminLayout>
    <div className="site-card-wrapper">
    <Row gutter={16}>
      <Col span={8}>
      </Col>
      <Col span={8}>
            <Card
            bordered={false}
            className="home-card"
            >
            <p><u>{TranslateString('Welcome')}</u>  {UserService.getUsername()}</p>
            </Card>
      </Col>
      <Col span={8}>
      </Col>
    </Row>
  </div>
      
        </AdminLayout>
    </>
 );
};
export default HomeLayout;